import React from "react";
import { Link } from "react-router-dom";

export const products = [
  {
    name: "Hinge Containers (Duo Front Tabs)",
    images: [
      "/images/V/V93W.png",
      "/images/V/V61W.png",
      "/images/V/V91W.png",
      "/images/V/V96W.png",
    ],
    description: `Perfect option for any establishment shifting towards
environmentally conscious packaging solutions. A
great alternative to styrofoam. Dual front tabs make
these easy to open.`,
    features: [
      "BPA Free",
      "Recyclable",
      "Freezer Safe",
      "Microwave Safe",
      "Stackable",
      "Water & Oil Resistant",
      "Durable in 0°F/-18°C to 180°F/82.2°C",
    ],
    specs: [
      {
        label: "SKU",
        values: ["V61", "V96", "V81", "V83", "V91", "V93"],
      },
      {
        label: "Name",
        values: [
          "6x6 MFPP Hinged Container (White)",
          "9x6 MFPP Hinged Container (White)",
          "8x8 MFPP Hinged Container (White)",
          "8x8 3-Cpt MFPP Hinged Container (White)",
          "9x9 MFPP Hinged Container (White)",
          "9x9 3-Cpt MFPP Hinged Container (White)",
        ],
      },
      { label: "Vents", values: [0, 0, 4, 4, 4, 4] },
      { label: "Compartments", values: [1, 1, 1, 3, 1, 3] },
      {
        label: "Product Dimensions (in)",
        values: [
          "6 × 6 × 3.25",
          "9 × 6.25 × 2.75",
          "8 × 8 × 3",
          "8 × 8 × 3",
          "9 × 9 × 3",
          "9 × 9 × 3",
        ],
      },
      {
        label: "Case Pack",
        values: ["250pc", "200pc", "150pc", "150pc", "150pc", "150pc"],
      },
    ],
    link: "/products/hingedduo",
  },
  {
    name: "Hinge Containers (Center Slide)",
    images: [
      "/images/CS/CS601.png",
      "/images/CS/CS903.png",
      "/images/CS/CS905.png",
    ],
    description: `Perfect option for any establishment shifting towards
environmentally conscious packaging solutions. A
great alternative to styrofoam.`,
    features: [
      "BPA Free",
      "Recyclable",
      "Freezer Safe",
      "Microwave Safe",
      "Stackable",
      "Water & Oil Resistant",
      "Durable in 0°F/-18°C to 180°F/82.2°C",
    ],
    specs: [
      {
        label: "SKU",
        values: ["CS601", "CS905", "CS801", "CS803", "CS901", "CS903"],
      },
      {
        label: "Name",
        values: [
          "5.5x5.4 MFPP Clamshell Center Slide",
          "9x5.5 MFPP Clamshell Center Slide",
          "8x8 MFPP Clamshell Center Slide",
          "8x8 3-Cpt MFPP Clamshell Center Slide",
          "9.5x9.25 MFPP Clamshell Center Slide",
          "9.5x9.25 3-Cpt MFPP Clamshell Center Slide",
        ],
      },
      { label: "Compartments", values: [1, 1, 1, 3, 1, 3] },
      {
        label: "Product Dimensions (in)",
        values: [
          "5.5 × 5.4 × 3",
          "9 × 5.5 × 3",
          "8 × 8 × 2.5",
          "8 × 8 × 2.5",
          "9.5 × 9.25 × 3",
          "9.5 × 9.25 × 3",
        ],
      },
      {
        label: "Case Pack",
        values: ["250 pc", "200 pc", "150 pc", "150 pc", "150 pc", "150 pc"],
      },
    ],
    link: "/products/centerslide",
  },
  {
    name: "Deli Containers",
    images: [
      "/images/Deli/S8.png",
      "/images/Deli/S12.png",
      "/images/Deli/S16.png",
      "/images/Deli/S24.png",
      "/images/Deli/S32.png",
    ],
    description: `Reliable, airtight, and leak-proof storage solution for
your soups, stews, curries, and more.`,
    features: [
      "Leakproof",
      "Stackable",
      "Reusable & Recyclable",
      "Freezer Safe",
      "Microwave Safe",
      "Dishwasher Safe",
      "Water & Oil Resistant",
      "Durable in 0°F/-18°C to 180°F/82.2°C",
    ],
    specs: [
      {
        label: "SKU",
        values: ["S8", "S12", "S16", "S24", "S32"],
      },
      {
        label: "Name",
        values: [
          "8oz Heavy Duty Soup Container",
          "12oz Heavy Duty Soup Container",
          "16oz Heavy Duty Soup Container",
          "24oz Heavy Duty Soup Container",
          "32oz Heavy Duty Soup Container",
        ],
      },
      {
        label: "Product Dimensions Base (in)",
        values: [
          "⌀4.63 × 1.69",
          "⌀4.63 × 2.17",
          "⌀4.63 × 3.05",
          "⌀4.63 × 4.33",
          "⌀4.63 × 5.61",
        ],
      },
      {
        label: "Product Dimensions Lid (in)",
        values: [
          "⌀4.72 × 0.35",
          "⌀4.72 × 0.35",
          "⌀4.72 × 0.35",
          "⌀4.72 × 0.35",
          "⌀4.72 × 0.35",
        ],
      },
      {
        label: "Capacity",
        values: ["8 oz", "12 oz", "16 oz", "24 oz", "32 oz"],
      },
      {
        label: "Case Pack",
        values: ["240 sets", "240 sets", "240 sets", "240 sets", "240 sets"],
      },
    ],
    link: "/products/deli",
  },
  {
    name: "Portion Cups",
    images: [
      "/images/PC/P075.png",
      "/images/PC/P100.png",
      "/images/PC/P150.png",
      "/images/PC/P200.png",
      "/images/PC/P325.png",
      "/images/PC/P400.png",
      "/images/PC/P550.png",
    ],
    description: `Small, leak-proof cups for condiments, sauces, sides,
toppings, and samples.`,
    features: [
      "BPA Free",
      "Stackable",
      "Reusable & Recyclable",
      "Freezer Safe",
      "Microwave Safe (Cup only)",
      "Dishwasher Safe (Cup only)",
      "Water & Oil Resistant",
      "Cups made of polypropylene, durable in 0°F/-18°C to 180°F/82.2°C",
      "Lids made of PET",
    ],
    specs: [
      {
        label: "SKU",
        values: [
          "PC075",
          "PC100",
          "PC150",
          "PC200",
          "PC325",
          "PC400",
          "PC550",
          "PC075100L",
          "PC150250L",
          "PC325550L",
        ],
      },
      {
        label: "Name",
        values: [
          "0.75oz Portion Cup",
          "1oz Portion Cup",
          "1.5oz Portion Cup",
          "2oz Portion Cup",
          "3.25oz Portion Cup",
          "4oz Portion Cup",
          "5.5oz Portion Cup",
          "Lid for 0.75 and 1oz Portion Cup",
          "Lid for 1.5 and 2oz Portion Cup",
          "Lid for 3.25, 4, and 5oz Portion Cup",
        ],
      },
      {
        label: "Product Type",
        values: [
          "Cup",
          "Cup",
          "Cup",
          "Cup",
          "Cup",
          "Cup",
          "Cup",
          "Lid",
          "Lid",
          "Lid",
        ],
      },
      {
        label: "Product Dimensions (in)",
        values: [
          "⌀1.76 × 0.91",
          "⌀1.76 × 1.23",
          "⌀2.45 × 0.85",
          "⌀2.45 × 1.18",
          "⌀2.91 × 1.38",
          "⌀2.91 × 1.61",
          "⌀2.91 × 2.28",
          "⌀1.89 × 0.2",
          "⌀2.6 × 0.2",
          "⌀2.99 × 0.31",
        ],
      },
      {
        label: "Capacity",
        values: [
          "0.75 oz",
          "1 oz",
          "1.5 oz",
          "2 oz",
          "3.25 oz",
          "4 oz",
          "5.5 oz",
          "-",
          "-",
          "-",
        ],
      },
      {
        label: "Case Pack",
        values: [
          "2500 pc",
          "2500 pc",
          "2500 pc",
          "2500 pc",
          "2500 pc",
          "2500 pc",
          "2500 pc",
          "2500 pc",
          "2500 pc",
          "2500 pc",
        ],
      },
    ],
    link: "/products/portion",
  },
  {
    name: "Round Containers",
    images: [
      "/images/Round/R16.png",
      "/images/Round/R24.png",
      "/images/Round/R32.png",
      "/images/Round/R40.png",
      "/images/Round/R48.png",
    ],
    description: `Table-ready microwavable containers suitable for
both hot and cold take out foods.`,
    features: [
      "Freezer Safe",
      "Microwave Safe",
      "Dishwasher Safe",
      "Leak Resistant",
      "Stackable",
      "Water & Oil Resistant",
      "Durable in 0°F/-18°C to 180°F/82.2°C",
    ],
    specs: [
      {
        label: "SKU",
        values: ["R16", "R24", "R32", "R40", "R48"],
      },
      {
        label: "SKU",
        values: [
          "16oz Round Microwaveable Container with Lid",
          "24oz Round Microwaveable Container with Lid",
          "32oz Round Microwaveable Container with Lid",
          "40oz Round Microwaveable Container with Lid",
          "48oz Round Microwaveable Container with Lid",
        ],
      },
      {
        label: "Product Dimensions (Base in)",
        values: [
          "⌀6.3 × 1.7",
          "⌀7.3 × 1.7",
          "⌀7.3 × 2",
          "⌀7.3 × 2.6",
          "⌀9 × 1.8",
        ],
      },
      {
        label: "Product Dimensions (Lid in)",
        values: [
          "⌀6.34 × 0.6",
          "⌀7.36 × 0.6",
          "⌀7.36 × 0.6",
          "⌀7.36 × 0.6",
          "⌀9 × 0.65",
        ],
      },
      {
        label: "Capacity",
        values: ["16 oz", "24 oz", "32 oz", "40 oz", "48 oz"],
      },
      {
        label: "Case Pack",
        values: ["150 sets", "150 sets", "150 sets", "150 sets", "150 sets"],
      },
    ],
    link: "/products/round",
  },
  {
    name: "Noodle Bowls",
    images: [
      "/images/Noodle/NB36.png",
      "/images/Noodle/NB42.png",
      "/images/Noodle/NB502.png",
    ],
    description: `Crafted for convenience, the insert separates dry and
wet ingredients, and the 50-oz bowl allows diners to
feast wherever they are without needing to transfer
to another bowl. Suitable for takeout and
in-restaurant dining.`,
    features: [
      "BPA Free",
      "Reusable & Recyclable",
      "Freezer Safe",
      "Microwave Safe",
      "Dishwasher Safe",
      "Stackable",
      "Leak Resistant",
      "Water & Oil Resistant",
      "Durable in 0°F/-18°C to 180°F/82.2°C",
    ],
    specs: [
      {
        label: "SKU",
        values: ["NB36", "NB42", "NB502"],
      },
      {
        label: "Name",
        values: [
          "36oz Noodle Bowl",
          "42oz Noodle Bowl",
          "50oz Noodle Bowl with Insert",
        ],
      },
      {
        label: "Product Dimensions (in)",
        values: ["⌀7 × 3.3", "⌀7 × 3.75", "⌀7.5 × 4"],
      },
      {
        label: "Capacity",
        values: ["36 oz", "42 oz", "50 oz"],
      },
      {
        label: "Case Pack",
        values: ["120 sets", "120 sets", "90 sets"],
      },
    ],
    link: "/products/noodle",
  },
  {
    name: "Rectangular Containers",
    images: [
      "/images/E/E12.png",
      "/images/E/E16.png",
      "/images/E/E24.png",
      "/images/E/E28.png",
      "/images/E/E32.png",
    ],
    description: `Space-efficient table-ready containers suitable for
both hot and cold take out foods.`,
    features: [
      "BPA Free",
      "Reusable & Recyclable",
      "Freezer Safe",
      "Microwave Safe",
      "Dishwasher Safe",
      "Stackable",
      "Leak Resistant",
      "Water & Oil Resistant",
      "Durable in 0°F/-18°C to 180°F/82.2°C",
    ],
    specs: [
      {
        label: "SKU",
        values: ["E12", "E16", "E24", "E28", "E32"],
      },
      {
        label: "Name",
        values: [
          "12oz Rectangular Microwaveable Container with Lid",
          "16oz Rectangular Microwaveable Container with Lid",
          "24oz Rectangular Microwaveable Container with Lid",
          "28oz Rectangular Microwaveable Container with Lid",
          "32oz Rectangular Microwaveable Container with Lid",
        ],
      },
      {
        label: "Product Dimensions (Base in)",
        values: [
          "6 × 4.6 × 1.5",
          "7.8 × 5.3 × 1.3",
          "7.8 × 5.3 × 1.65",
          "8.8 × 6 × 1.53",
          "8.8 × 6 × 1.68",
        ],
      },
      {
        label: "Product Dimensions (Lid in)",
        values: [
          "6 × 4.8 × 0.67",
          "7.9 × 5.4 × 0.7",
          "7.9 × 5.4 × 0.7",
          "9 × 6 × 0.7",
          "9 × 6 × 0.7",
        ],
      },
      {
        label: "Capacity",
        values: ["12 oz", "16 oz", "24 oz", "28 oz", "32 oz"],
      },
      {
        label: "Case Pack",
        values: ["150 sets", "150 sets", "150 sets", "150 sets", "150 sets"],
      },
    ],
    link: "/products/rectangular",
  },
  {
    name: "Compartmental Containers",
    images: [
      "/images/Compartment/TY232.png",
      "/images/Compartment/TY333.png",
      "/images/Compartment/TY339.png",
    ],
    description: `All-in-one container, separating entrées from sides
and dry from wet ingredients. `,
    features: [
      "BPA Free",
      "Reusable & Recyclable",
      "Freezer Safe",
      "Microwave Safe",
      "Dishwasher Safe",
      "Stackable",
      "Leak Resistant",
      "Water & Oil Resistant",
      "Durable in 0°F/-18°C to 180°F/82.2°C",
    ],
    specs: [
      {
        label: "SKU",
        values: ["TY232", "TY333", "TY339"],
      },
      {
        label: "Name",
        values: [
          "32oz Rectangular Microwaveable Container with Lid 2-compartment",
          "33oz Rectangular Microwaveable Container with Lid 3-compartment",
          "39oz Rectangular Microwaveable Container with Lid 3-compartment",
        ],
      },
      {
        label: "Product Dimensions (Base in)",
        values: ["8.85 × 6.1 × 1.69", "9 × 6.74 × 1.56", "9.65 × 7.59 × 1.57"],
      },
      {
        label: "Product Dimensions (Lid in)",
        values: [
          "8.92 × 6.18 × 0.72",
          "9.05 × 6.81 × 0.75",
          "9.73 × 7.67 × 0.63",
        ],
      },
      {
        label: "Compartments",
        values: [2, 3, 3],
      },
      {
        label: "Capacity",
        values: ["32 oz", "33 oz", "39 oz"],
      },
      {
        label: "Case Pack",
        values: ["150 sets", "150 sets", "150 sets"],
      },
    ],
    link: "/products/compartment",
  },
  {
    name: "PET Cold Cups",
    images: [
      "/images/CC/12.png",
      "/images/CC/16.png",
      "/images/CC/24.png",
      "/images/CC/lids.png",
    ],
    description: `Clear PET cups for all your drinks. Lids sold separately. Dome lids coming soon..`,
    features: [
      "Shatterproof",
      "ClearDesign",
      "FoodGrade",
      "Refrigerator Safe",
      "Leak Resistant",
      "Recyclable",
    ],
    specs: [
      {
        label: "SKU",
        values: ["CC12", "CC16", "CC20", "CC24", "CC98L", "CC32", "CC108L"],
      },
      {
        label: "Name",
        values: [
          "12oz PET Cold Cup",
          "16oz PET Cold Cup",
          "20oz PET Cold Cup",
          "24oz PET Cold Cup",
          "Lids for 12-24oz PET Cold Cups",
          "32oz PET Cold Cup",
          "Lids for 32oz PET Cold Cups",
        ],
      },
      {
        label: "Case Pack",
        values: [
          "1000pc",
          "1000pc",
          "1000pc",
          "600pc",
          "1000pc",
          "500pc",
          "500pc",
        ],
      },
    ],
    link: "/products/coldcup",
  },
  {
    name: "Paper Hot Cups",
    images: [
      "/images/HC/cups.png",
      "/images/HC/lidcup.png",
      "/images/HC/lid1.png",
      "/images/HC/lid2.png",
    ],
    description: `White paper cups for serving coffee, tea, and hot cocoa.`,
    features: [
      "Stackable",
      "Leak Free",
      "BPA Free",
      "Disposable",
      "No PFAs Added",
    ],
    specs: [
      {
        label: "SKU",
        values: ["HC12", "HC16", "HC20", "HCLW", "HCLB"],
      },
      {
        label: "Name",
        values: [
          "12oz Paper Hot Cup",
          "12oz Paper Hot Cup",
          "16oz Paper Hot Cup",
          "20oz Paper Hot Cup",
          "White Lids for 12-20oz Paper Hot Cups",
          "Black Lids for 12-20oz Paper Hot Cups",
        ],
      },
      {
        label: "Case Pack",
        values: ["1000pc", "1000pc", "600pc", "1000pc", "1000pc"],
      },
    ],
    link: "/products/hotcup",
  },
];

const Products = () => {
  return (
    <div className="bg-containx-navy min-h-screen p-6">
      <h1 className="text-4xl font-bold text-center mb-6 text-white">
        Our Containers
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {products.map((product, index) => (
          <div
            key={index}
            className="bg-containx-charcoal/30 text-white rounded-lg shadow-md overflow-hidden hover:bg-containx-beige/50 hover:text-containx-navy transition-shadow duration-200"
          >
            <Link to={product.link}>
              <img
                src={product.images[0]}
                alt={product.name}
                className="w-full h-48 object-contain"
              />
              <div className="p-4">
                <h2 className="text-xl font-semibold">{product.name}</h2>
                <p className="text-gray-700">{product.description}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
